export default "__VITE_ASSET__Cg_GaJ3X__"